import {Container, Row, Col} from 'react-bootstrap';
import {useLanguageContext, useThemeContext} from '../../../context';
import List from './List';
import withObservables from '@nozbe/with-observables';
import NonIdealScreen from '../NonIdeal';
import {useNavigate} from 'react-router-dom';
import {PosAppModal} from '../V2';
import {useSearch} from '../../../hooks';
import SearchBox from '../SearchBox';
import {DEVICE_HEIGHT} from '../../../constants';
import useFocus from '../../../hooks/useFocus';
import {useEffect} from 'react';
import usePermission from '../../../hooks/usePermission';
import {observeUnArchivedSalesTax} from '../../../pos-core/database/helpers';

const TaxesModal = ({toggle, setToggle, salesTax, handleSelect, data}) => {
    const navigate = useNavigate();
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();

    const {text, setText, searchList} = useSearch(handleSearch);
    const {textBoxRef, handleFocus} = useFocus(true);
    const userPermission = usePermission('tax');

    useEffect(() => {
        handleFocus();
    }, [toggle]);

    const handleClose = event => {
        setToggle(false);
    };

    function handleSearch(val) {
        return salesTax?.filter(x => x.name.toLowerCase().includes(val.toLowerCase()));
    }
    const handleCreateSalesTax = () => {
        navigate('/tax/sales/create', {state: {screenName: 'item_creation'}});
    };

    const onChange = (event, key) => {
        let value = key || event?.target?.value || '';

        setText(value);
    };

    return (
        <PosAppModal
            className="selectCustomerModal"
            toggle={toggle}
            backCta={{
                name: 'backArrowIcon',
                fill: theme.barclaysBlue,
                width: '18',
                height: '18',
                viewBox: '0 0 18 18',
            }}
            handleClose={handleClose}
            rightCta={
                userPermission?.canCrud &&
                salesTax?.length && {
                    title: I18n.create_sales_tax,
                    action: handleCreateSalesTax,
                    iconName: 'add2Icon',
                    fill: theme.barclaysBlue,
                    width: '18',
                    height: '18',
                    viewBox: '0 0 18 18',
                }
            }
            hideFooter={true}
            title={I18n.sales_tax}>
            {!salesTax.length == 0 && (
                <SearchBox
                    type="pos"
                    placeholder={I18n.search_by_name}
                    prefix={{
                        name: 'search2Icon',
                        fill: theme.white,
                    }}
                    onChange={onChange}
                    inputRef={textBoxRef}
                />
            )}

            <Container fluid>
                <Row className="justify-content-md-center">
                    <Col>
                        {salesTax.length ? (
                            <div
                                className="selectCustomerListBox"
                                style={{
                                    height: DEVICE_HEIGHT - 230,
                                }}>
                                {(text ? searchList : salesTax)?.map((val, index) => (
                                    <List key={index} val={val} data={data} handleClick={handleSelect} />
                                ))}
                            </div>
                        ) : (
                            <NonIdealScreen
                                heading={I18n.create_sales_tax}
                                subHeading={I18n.no_Sales_tax_found}
                                name="taxNewIcon"
                                fill={theme.white}
                                primaryCta={
                                    userPermission?.canCrud
                                        ? {
                                              title: I18n.create_sales_tax,
                                              action: handleCreateSalesTax,
                                          }
                                        : null
                                }
                                isMultiStep={false}
                            />
                        )}
                    </Col>
                </Row>
            </Container>
        </PosAppModal>
    );
};

const enhance = withObservables([], () => ({
    salesTax: observeUnArchivedSalesTax(),
}));

export default enhance(TaxesModal);
